import { Link, useNavigate, useParams } from 'react-router-dom';
import { useConfig, useGuardarTabla } from '../api/hooks';
import { SinPermiso } from '../components/SiPuede';
import { TablaForm } from '../components/TablaForm';
import { useSesion } from '../context/Sesion';
import { camposDesdeForm, formDesdeTabla, formVacio, type FormTabla } from '../utils/validacion';

/** Alta (/tablas/nueva) y edición (/tablas/:tabla/editar) de una tabla. dwh.editor. */
export function TablaEditarPage() {
  const { tabla } = useParams();
  const nueva = tabla === undefined;
  const { puede } = useSesion();
  const config = useConfig();
  const guardar = useGuardarTabla(nueva ? undefined : tabla);
  const navegar = useNavigate();

  if (!puede('dwh.editor')) return <SinPermiso rol="dwh.editor" />;
  if (config.isLoading) return <p className="cargando">Cargando…</p>;
  if (config.error) return <div className="aviso aviso-error">{config.error.message}</div>;
  const v = config.data!;
  const t = nueva ? undefined : v.tablas.find((x) => x.tabla === tabla);
  if (!nueva && !t) return <div className="aviso aviso-error">La tabla {tabla} no está en la configuración.</div>;

  const alGuardar = async (f: FormTabla) => {
    const r = await guardar.mutateAsync({ tabla: camposDesdeForm(f, nueva), motivo_cambio: f.motivo_cambio.trim(), version_base: v.id });
    navegar(`/tablas/${r.tabla ?? f.nombre.trim().toUpperCase()}`);
  };

  return (
    <>
      <p className="miga">
        <Link to="/tablas">Tablas</Link> / {nueva ? 'Nueva' : <Link to={`/tablas/${tabla}`}>{tabla}</Link>}
      </p>
      <h1>{nueva ? 'Añadir una tabla de X3' : `Editar ${tabla}`}</h1>
      <p className="subtitulo">
        Se guarda como una versión nueva de la configuración (sobre la {v.id}). Airflow la aplica en su próxima pasada.
      </p>
      <TablaForm inicial={t ? formDesdeTabla(t) : formVacio(v.defecto)} nueva={nueva} alGuardar={alGuardar} alCancelar={() => navegar(-1)} />
    </>
  );
}
